/**
 * REGELEN OM SIDE (D2, QA13 #110 — Atles tabell).
 *
 * | Handling                              | Arrangør | Byrå, management, musikere, reisefølge, gjest |
 * |---------------------------------------|----------|-----------------------------------------------|
 * | Legge til gjester over avtalt antall  | Ja       | Nei, stoppes ved maks                         |
 * | Kvittere ut ankomne                   | Ja       | Nei                                           |
 * | Sette akkrediteringsnivå              | Ja       | Nei                                           |
 * | Se arrangørens økonomi                | Ja       | Nei                                           |
 * | Legge inn eller endre «Andre fra       | Ja       | Nei (K4 F12: byråets rad sto som festivalens   |
 * |   festivalen» (festivalens egne folk)  |          |   kontaktperson)                              |
 *
 * Det er en produktregel om SIDE, ikke en celle i matrisen: `performance:update` slipper motparten
 * inn på en delt advance, og en gjest med «Kan endre» likeså — uansett hva cellene sier, får de
 * aldri de fire. Arrangøren er huset programposten hører til, og bare et MEDLEM av det: en gjest står
 * i huset, men er ikke huset.
 *
 * ÉN FUNKSJON, spurt av `can()` for økonomien (en rad i et annet hus) og av API-et og weben for de
 * tre som ikke er egne handlinger (taket, utkvitteringen og nivået ligger i `performance:update`).
 * Kalleren gir programpostens hus; serveren slår det opp med `app.performance_org`, weben vet om
 * den står som motpart.
 */
import type { Actor, DenyReason } from './types.js';

export const ORGANISER_ONLY = [
  'guests_over_cap',
  'check_out_arrivals',
  'set_accreditation_level',
  'organiser_economy',
  'organiser_people',
] as const;
export type OrganiserOnly = (typeof ORGANISER_ONLY)[number];

/**
 * Står aktøren på arrangørens side av `owner` (programpostens organisasjon)? `null` er «ukjent
 * eier» og svarer nei: en ukjent eier er ikke din.
 */
export function organiserSide(
  actor: Pick<Actor, 'organizationId' | 'orgRole'> | null,
  _what: OrganiserOnly,
  owner: string | null,
): true | DenyReason {
  if (actor === null || actor.orgRole === 'guest') return 'organiser_only';
  return owner !== null && owner === actor.organizationId ? true : 'organiser_only';
}
